import * as fromDatatype from '../datatype-library/index';

export interface bl_rvm_cfp_engagement_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  program_hdr_guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  conglomerate_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_branch_guid: fromDatatype.GuidDataFieldInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
}

export class bl_rvm_cfp_engagement_hdr_RowClass
  implements bl_rvm_cfp_engagement_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  program_hdr_guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  conglomerate_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_branch_guid: fromDatatype.GuidDataFieldInterface;
  process_status: fromDatatype.VarcharDatatypeInterface;
}
